import React from 'react';
import Draggable from 'react-draggable';
const PopupStyle = {

"position":"fixed",
"top":"0",
"left":"0",
"right":"0",
"bottom":"0",
"maxWidth" : "50%",
"maxHeight" : "50%",
"margin":"auto",
"borderRadius":"20px",
"backgroundColor":"rgba(0,0,0, 0.6)",
"zIndex": "10",
}
const InnerPopupStyle = 

{"position":"absolute",
"left":"5%",
"right":"5%",
"color": "#3d3d3d",
"top":"10%",
"bottom":"5%",
"margin":"auto",
"borderRadius":"20px",
"background":"white",
"text":"left",
"overflow" : "auto",
}

const DataStyle = 
{
  "marginTop":"5%",
  "marginBottom":"5%",
 }
const butStyle = 
{
  "zIndex" : "50,"
}

class Popup extends React.Component {  
  render() { 

   
return (  
  <Draggable
        axis="both"
        handle=".handle"
        defaultPosition={{x: 0, y: 0}}
        position={null}
        grid={[25, 25]}
        scale={1}
        onStart={this.handleStart}
        onDrag={this.handleDrag}
        onStop={this.handleStop}>
    <div  style={PopupStyle} className='handle'>  
<div className="d-flex justify-content-end m-0">
<button style={butStyle} className="btn btn-md btn-secondary bottom m-1" onClick={this.props.closePopup}><span role="img" aria-label="close">&#10060;</span></button> 
</div>
<div  style={InnerPopupStyle} className='popup\_inner'>  
<div style={DataStyle}>
<pre className="text-left row m-2 container-fluid">{this.props.data}</pre>
 </div>
</div>  
</div>  
</Draggable>
);  
}  
}  

export default Popup;